import api from '@/api'
import {
  SET_BECOME_CGTALKS_LIST,
  SET_RECOMMEND_CGTALKS_LIST,
  SET_REGISTER_CGTALKS_LIST,
} from './mutation-types'
const state = {
  becomeDatasource: [],
  recommendDataSource: [],
  registerDatasource: [],
  loading: false,
}
const mutations = {
  [SET_BECOME_CGTALKS_LIST](state, payload) {
    state.becomeDatasource = payload
  },
  [SET_RECOMMEND_CGTALKS_LIST](state, payload) {
    state.recommendDataSource = payload
  },
  [SET_REGISTER_CGTALKS_LIST](state, payload) {
    state.registerDatasource = payload
  },
}
const actions = {
  async getList({ commit }, payload) {
    const { type } = payload
    state.loading = true
    const { data, code } = await api.deployApi.queryCgtalksList(payload)
    state.loading = false
    if (code === 200) {
      switch (type) {
        case 0:
          commit(SET_RECOMMEND_CGTALKS_LIST, data || [])
          break
        case 1:
          commit(SET_BECOME_CGTALKS_LIST, data || [])
          break
        case 2:
          commit(SET_REGISTER_CGTALKS_LIST, data || [])
          break
      }
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
